import { render, staticRenderFns } from "./LocationsDialogGrid.vue?vue&type=template&id=60221fea&scoped=true&"
import script from "./LocationsDialogGrid.vue?vue&type=script&lang=js&"
export * from "./LocationsDialogGrid.vue?vue&type=script&lang=js&"
import style0 from "./LocationsDialogGrid.vue?vue&type=style&index=0&id=60221fea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60221fea",
  null
  
)

/* custom blocks */
import block0 from "./LocationsDialogGrid.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports